/** Smooth — re-flow open strokes through their anchor points. */
import type { AffectModule } from '../../core/module-api';
import { cloneShape } from '../../core/scene';
import { buildSmoothPath, pathAnchors } from '../../core/geometry';

const ICON =
  '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M3 17c0-8 6-8 9-8s9 0 9-8"/></svg>';

export function createSmooth(): AffectModule {
  return {
    manifest: {
      id: 'smooth',
      kind: 'affect',
      name: 'Smooth',
      apiVersion: 1,
      description: 'Relax open strokes into smoother curves.',
      icon: ICON,
    },

    affect(shapes) {
      return shapes.map((s) => {
        const hasFill = s.style.mode === 'fill' || s.path.segments.some((seg) => seg.t === 'Z');
        if (hasFill) return cloneShape(s);
        const anchors = pathAnchors(s.path);
        if (anchors.length < 3) return cloneShape(s);
        const c = cloneShape(s);
        c.path = buildSmoothPath(anchors);
        return c;
      });
    },
  };
}
